import { useRef } from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function FilePickerButton({
  id,
  name,
  multiple,
  disabled,
  accept,
  onPick,
  chosenLabel,
  className,
}: {
  id?: string;
  name?: string;
  multiple?: boolean;
  disabled?: boolean;
  accept?: string;
  onPick: (files: FileList | null) => void;
  chosenLabel: string;
  className?: string;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const statusId = id ? `${id}-status` : undefined;

  return (
    <div className={cn('flex flex-wrap items-center gap-3', className)}>
      <input
        ref={inputRef}
        id={id}
        name={name}
        type="file"
        multiple={multiple}
        disabled={disabled}
        accept={accept}
        className="sr-only"
        tabIndex={-1}
        aria-describedby={statusId}
        onChange={(event) => {
          onPick(event.target.files);
          event.target.value = '';
        }}
      />
      <Button
        type="button"
        variant="outline"
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
      >
        Datei auswählen
      </Button>
      <span id={statusId} className="text-sm text-muted-foreground">
        {chosenLabel}
      </span>
    </div>
  );
}
